<template>
    <!-- 正规持牌支付机构  -->
    <sub-page :title="title" :subtitle="subtitle" :description="description" :button-text="buttonText" :bg="bg"
        :right-bg="rightBg" :partition="[7, 5]"  />
</template>

<script>
import SubPage from '@/views/components/SubPage.vue'
export default {
    name: 'organization',
    components: {
        SubPage
    },
    data() {
        return {
            bg: "/img/pay/0--36.png",
            rightBg: "/img/pay/0--43.png",
            rightBg2: "img/pay/0--60.png"
        }
    },
    computed: {
        title() {
            return this.$t('organization.title');
        },
        subtitle() {
            return this.$t('organization.subtitle');
        },
        description() {
            return [this.$t('organization.description1')];
        },
        buttonText() {
            return this.$t('common.buttonText');
        }
    }
}
</script>